// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'swiper/dist/css/swiper.css'

import Vue from 'vue'

import App from './App'

import axios from 'axios'
import VueAxios from 'vue-axios'
import router from './router'
import store from '@/store/store'
import Vuex from 'vuex'
import BootstrapVue from 'bootstrap-vue'
import vueMoment from 'vue-moment'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import VueChatScroll from 'vue-chat-scroll'
import upperFirst from 'lodash/upperFirst'
import camelCase from 'lodash/camelCase'

Vue.use(BootstrapVue)
Vue.use(Vuex)
Vue.use(VueAxios, axios)
Vue.use(vueMoment)
Vue.use(VueAwesomeSwiper)
Vue.use(VueChatScroll)

Vue.config.productionTip = false

// Global components auto registering.
const requireComponent = require.context(
  './components', true, /Base[A-Z]\w+\.(vue|js)$/
)

requireComponent.keys().forEach(fileName => {
  const componentConfig = requireComponent(fileName)
  const componentName = upperFirst(
    camelCase(fileName.split('/').pop().replace(/\.\w+$/, ''))
  )
  Vue.component(componentName, componentConfig.default || componentConfig)
})
// Global components auto registering.

const app = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

if (window.Cypress) {
  window.app = app
}



// WEBPACK FOOTER //
// ./src/main.js